import script from "./CustomerProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerProfileView.vue?vue&type=script&setup=true&lang=js"

import "./CustomerProfileView.vue?vue&type=style&index=0&id=fee31b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee31b02"]])

export default __exports__